import React, { Component } from "react";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
class CommissionNote extends Component {
    constructor(props) {
        super(props);

        this.state = {
            topic: props.currentEvent.topic,
            title: props.currentEvent.title,
            time: props.currentEvent.time,
            date: props.selectedDate,
            note: props.currentEvent.note,
            id: props.currentEvent.id,

        };
        this.listMeetings=this.listMeetings.bind(this);
    }
    listMeetings() {
        let self = this;
        let params = {
            url: API_BASE_URL+'/allMeets' ,
            method: "get",
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                let listMeeting = response.data;
                self.setState({
                    listMeeting,
                    loading: false,
                    searching: false,
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });

    }
    componentDidMount() {
        this.listMeetings();
    }
    render() {
        const event = new Date(this.state.date);
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const time = this.state.time;
        const newTime = time.split(":");
        const saat=parseInt(newTime[0],10);
        const dakika=parseInt(newTime[1],10);
        const  saniye=parseInt(newTime[2],10);
        const yeniSaat=saat+1;
        const yeniToplantiSaati = `${String(yeniSaat).padStart(2, '0')}:${String(dakika).padStart(2, '0')}:${String(saniye).padStart(2, '0')}`;
        return (
            <div className="oda-form-container">
                <div className="card-body mt-1">
                    <div className="FormRenk col-sm-12">
                        <div className="col-sm-12 row">
                            <div className="col-sm-4">
                                <label>Toplantı Tarihi:</label>
                            </div>
                            <div className="col-sm-8">
                                <input
                                    value={event.toLocaleDateString(undefined, options)}
                                    type="text"
                                    disabled
                                    style={{width:"100%"}}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-4">
                                <label>Toplantı Konusu:</label>
                            </div>
                                <div className="col-sm-8">
                                <textarea rows="3"
                                    value={this.state.title}
                                    type="text" disabled
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-4">
                                <label>Toplantı Saati:</label>
                            </div>
                                <div className="col-sm-8">
                                <input
                                    value={yeniToplantiSaati}
                                    // value={this.state.time}
                                    type="text"
                                    style={{width:"100%"}}
                                    disabled
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
export default CommissionNote;



// WEBPACK FOOTER //
// ./src/page/agenda/CommissionNote.js